<script>
export default {
 methods: {
  isActive(path) {
   return this.$route.path === path;
  },
 },
};
</script>

<template>
<div class="col-xl-3 theiaStickySidebar">
<div class="card">
<div class="card-body">
<div class="d-flex flex-column list-group settings-list">
  
  <router-link to="/financial-settings/taxes" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active">
   <i v-if="isActive('/financial-settings/taxes')" class="ti ti-arrow-badge-right me-2"></i>Tax Rates</router-link>

</div>
</div>
</div>
</div>
</template>
